import type {CreateControllerFn} from '@wix/yoshi-flow-editor';

export const conditionalController =
  (
    experimentName: string,
    controllerWhenTrue: CreateControllerFn,
    controllerWhenFalse: CreateControllerFn
  ): CreateControllerFn =>
  (controllerParams) => {
    if (!controllerParams.controllerConfig.essentials.experiments.enabled(experimentName)) {
      return controllerWhenFalse(controllerParams);
    }

    return controllerWhenTrue(controllerParams);
  };
